module.exports = "<div class=\"tab-pane\" [attr.id]=\"id\" role=\"tabpanel\" [hidden]=\"!active\">\n\t<ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/shared/tabs/tab/tab.component.html
// module id = ../../../../../src/app/shared/tabs/tab/tab.component.html
// module chunks = main